export default __webpack_public_path__ + "static/media/nk.312dfe8a.jpeg";